import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import StickyMobileCTA from "./components/StickyMobileCTA";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import TrackDelivery from "./pages/TrackDelivery";
import CustomerPortal from "./pages/CustomerPortal";
import DriverDelivery from "./pages/DriverDelivery";
import Partners from "./pages/Partners";
import LegalPolicies from "./pages/LegalPolicies";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider, ProtectedRoute } from "./context/AuthContext";

function App() {
  return (
    <div className="App min-h-screen bg-brand-navy flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            {/* Admin Routes - No Navigation/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Driver Delivery Route with jobId param - No Navigation/Footer */}
            <Route path="/deliver/:jobId" element={<DriverDelivery />} />
            
            {/* Public Routes - With Navigation/Footer */}
            <Route
              path="/*"
              element={
                <>
                  <Navigation />
                  <main className="flex-grow">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/services" element={<Services />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/careers" element={<Careers />} />
                      <Route path="/partners" element={<Partners />} />
                      <Route path="/legal" element={<LegalPolicies />} />
                      <Route path="/privacy" element={<LegalPolicies />} />
                      <Route path="/terms" element={<LegalPolicies />} />
                      <Route path="/track" element={<TrackDelivery />} />
                      <Route path="/deliver" element={<DriverDelivery />} />
                      <Route path="/my-deliveries" element={<CustomerPortal />} />
                    </Routes>
                  </main>
                  <Footer />
                  <StickyMobileCTA />
                </>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
